export default (_request, _options, response) => {
  const url = new URL(response.url || _request.url);
  let uri = url.pathname
    .replace(/^\//, "") // remove first /
    .replace(/^ajax\//, "") // remove ajax/
    .replace(/\.php/, ""); // remove .php

  if (excluded.includes(uri)) {
    return;
  }
  // always put a / on start
  uri = `/${uri}`;
  // response 200
};

const excluded = [
  "ReactWidget/config",
  "cache_ajax/faq_widget",
  "verif_info_user",
  "sequence_type_rdv",
  "validation_rdv",
  "get_user_liste_complete_ajax",
  "modification_liste_user_rdv",
  "enregistrement_rdv"
];
